export default __webpack_public_path__ + "static/media/bizlogo.bf4bfdd6.svg";